import { CHCGlossary } from './glossary.component.js';
export { CHCGlossary };

customElements.define('chcapp-glossary', CHCGlossary);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-glossary': CHCGlossary;
  }
}
